// 9fbef606107a605d69c0edbcd8029e5d
import Styled from 'styled-components';
import { getIconPath } from '@tcp/core/src/utils';

export const StyledHorizontalCarousel = Styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  ${(props) => props.shouldDisplayCategoryName && 'position:relative;'}
  .carousel-arrows{
    position: relative;
    height: auto;
    display: inline-flex;
    align-items: center;
    button{
      position: absolute;
    }
    .left-arrow{
      background: url(${() => getIconPath('carousel-big-carrot')}) no-repeat center center;
      outline: none;
      height: 40px;
      width: 18px;
      border: none;
      cursor: pointer;
      left: -21px;
      transform: rotate(180deg);
      display: none;
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
      }
    }
    .right-arrow{
      background: url(${() => getIconPath('carousel-big-carrot')}) no-repeat center center;
      outline: none;
      height: 40px;
      width: 18px;
      border: none;
      cursor: pointer;
      right: -28px;
      display: none;
      @media ${(props) => props.theme.mediaQuery.large} {
        display: block;
      }
    }
  }
`;

export const HorizontalScroll = Styled.div`
  margin: 0px;
  display: flex;
  overflow-x: scroll;
  scroll-behavior: smooth;
  height: 100%;
  overflow-y: hidden;
  white-space: nowrap;
  -ms-overflow-style: none;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
`;
export const HorizontalGrid = Styled.div`
  height: 100%;
  display: flex;
  gap: 8px;
`;
